import { createAsyncStoragePersister } from "@tanstack/query-async-storage-persister";
import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			refetchOnWindowFocus: false,
			refetchOnReconnect: false,
			retry: 0,
			gcTime: 1000 * 60 * 10,
			staleTime: 1000 * 60 * 5,
		},
	},
});

const persister = createAsyncStoragePersister({
	storage: {
		getItem: (key) => {
			try {
				return window.localStorage?.getItem(key) ?? null;
			} catch {
				return null;
			}
		},
		setItem: (key, value) => {
			try {
				window.localStorage?.setItem(key, value);
			} catch {}
		},
		removeItem: (key) => {
			try {
				window.localStorage?.removeItem(key);
			} catch {}
		},
	},
	key: "shell_queries",
});

export const persistConfig = {
	buster: import.meta.env.VITE_DEPLOY_VERSION,
	persister,
};
